import clsx from 'clsx';

// Helpers
import { IMetaProps } from '../inrefaces';
import { getCurrentStatusElement, getFormatedDate } from '../../utils';

const DialogMetaMobile: React.FC<IMetaProps> = ({ date, lastFromSupport, isReaded, className }) => {
    return (
        <div className={clsx('flex items-center justify-between w-full mt-4', className)}>
            <div className="mb-1 font-normal text-blueGray-500 text-[14px]">
                {getFormatedDate(date)}
            </div>

            {getCurrentStatusElement(isReaded, lastFromSupport)}

            {lastFromSupport === 1 && isReaded === 0 && (
                <div className="w-2 h-2 bg-red-400 rounded-full" />
            )}
        </div>
    );
};

export default DialogMetaMobile;
